import React, { SFC } from 'react';
import { Route, Switch } from 'react-router';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/GeneralSettings';
import block from 'propmods';

import { routes } from '../../lib/routes';
import Footer from '../Footer/Footer';
import GeneralSettings from '../GeneralSettings/GeneralSettings';
import Menu from '../Menu/Menu';
import { Page } from '../Typo/Typo';

import './AppSettingsPage.scss';

const t = i18n(keyset);
const b = block('AppSettingsPage');

const AppSettingsPage: SFC = () => {
    const menuItems = [
        {
            path: routes.app.settings(),
            title: t('tab-title-general-settings'),
            exact: true,
        },
    ];

    return (
        <Page>
            <Page.Head>
                <Page.HeadContent>
                    <h1 {...b('headline')}>{t('header-settings')}</h1>
                    <div {...b('nav')}>
                        <Menu items={menuItems} />
                    </div>
                </Page.HeadContent>
            </Page.Head>
            <Page.Content>
                <Page.Page>
                    <Switch>
                        <Route exact path={routes.app.settings()} render={() => <GeneralSettings />} />
                    </Switch>
                </Page.Page>
            </Page.Content>
            <Footer feedback={routes.documentation.aliceSkills.feedback} />
        </Page>
    );
};

export default AppSettingsPage;
